import { langToLocale, withLangPrefix, type Lang } from './i18n';

// SEO URL helpers for the public marketing pages. Each page passes its bare
// route (e.g. `/pocket`); these build the absolute, language-correct URLs used
// for canonical, og:url, hreflang alternates, and JSON-LD.

const ORIGIN = 'https://markflow.fyi';

/** Absolute self-URL for a route in a given language (EN at root, UK at /uk). */
export function publicUrl(routePath: string, lang: string): string {
  return `${ORIGIN}${withLangPrefix(routePath, lang)}`;
}

/**
 * Reciprocal hreflang set for a route: one entry per supported language plus an
 * `x-default` pointing at the EN version. Must be the same on every language
 * variant of the page or search engines ignore it.
 */
export function hreflangAlternates(
  routePath: string,
): Array<{ hreflang: string; href: string }> {
  return [
    { hreflang: 'en', href: publicUrl(routePath, 'en') },
    { hreflang: 'uk', href: publicUrl(routePath, 'uk') },
    { hreflang: 'x-default', href: publicUrl(routePath, 'en') },
  ];
}

/** Normalize i18next's resolved language to a supported code. */
export function activeLang(resolved: string | undefined): Lang {
  return resolved === 'uk' ? 'uk' : 'en';
}

/** Open Graph locale (underscore form, e.g. `uk_UA`). */
export function ogLocaleOf(lang: string): string {
  return langToLocale(lang).replace('-', '_');
}
